import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Tailwind sınıf birleştirici.
 *
 * Prototipte koşullu sınıflar template literal içinde birleştiriliyordu
 * (CalendarView.tsx:755). Sorun: Tailwind çakışan sınıfları (`px-5` ve `px-3.5`)
 * çözemez — kazanan, JSX'te son yazılan değil, üretilen CSS'te sonra tanımlanandır.
 * Bu, izini sürmesi çok zor sessiz stil hatalarına yol açar.
 *
 * `twMerge` çakışan Tailwind sınıflarında SON yazılanı kazandırır; `clsx`
 * koşullu birleştirmeyi okunur hale getirir.
 *
 * ## Neden yapılandırılmış bir twMerge?
 *
 * `tailwind-merge` sınıfları ADINDAN tanır ve varsayılan Tailwind ölçeğini
 * bilir. `@theme` içinde tanımlanan özel yazı ölçeğimizi (`text-body`,
 * `text-micro`, …) tanımaz ve `text-*` önekine bakıp bunları RENK sanır.
 *
 * Sonuç sessiz ve ciddiydi: `cn('text-white', 'text-body')` çağrısında ikisi
 * aynı çakışma grubuna düştüğü için biri atılıyordu. Butonlar arka planı
 * siyah, yazısı görünmez birer dikdörtgene dönüştü — CSS'te hata yok, konsolda
 * uyarı yok, sadece kaybolmuş bir etiket.
 *
 * Özel ölçeği açıkça bildirmek bu sınıf hatayı kökünden kapatır; yeni bir
 * boyut eklendiğinde buraya da eklenmelidir.
 */
/* Tanıtım sitesinin ölçekleri de burada OLMALI: listede olmayan
   `text-site-title` gibi bir sınıfı tailwind-merge RENK sanıp aynı
   öğedeki `text-ink` ile çakıştırıyor ve siliyordu — sitenin bölüm
   başlıkları bu yüzden gövde metni boyutunda çıkıyordu. */
const FONT_SIZES = [
  'micro',
  'label',
  'body',
  'read',
  'title',
  'display',
  'hero',
  'site-hero',
  'site-display',
  'site-title',
  'site-lead',
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...FONT_SIZES] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
